// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._72Und{position:fixed;top:calc(56px + 16px);right:16px;z-index:1001;overflow:hidden;display:flex;flex-direction:column;box-shadow:0px 4px 12px rgba(40,40,99,.06);box-sizing:content-box;transition:width 250ms ease-in-out,height 250ms ease-in-out}._72Und.SfmIa{width:482px;height:calc(100vh - 56px - 16px - 16px)}._72Und.ky5wc{width:260px;height:60px;cursor:pointer}.FJ0Y9{height:100%;width:100%;overflow:hidden;display:flex;flex-direction:column}.iPrNB{display:flex;align-items:center;gap:8px;padding:16px 20px;flex-shrink:0;border-bottom:1px solid transparent;transition:padding 250ms ease-in-out,border-bottom-color 150ms ease-in-out,box-shadow 150ms ease-in-out}.iPrNB.pZJyg{border-bottom-color:#d4d4e0;box-shadow:0px 4px 16px rgba(40,40,99,.08)}.ky5wc .iPrNB{padding:10px 14px}.kMvhq{display:inline-flex;align-items:center;gap:8px;white-space:nowrap}.RRTjT{display:inline-flex;align-items:center;padding:2px 8px;border:1px solid #aa7dfc;border-radius:10px;font-size:11px;font-weight:500;color:#7b47e8;background:#fff;text-transform:uppercase;letter-spacing:.5px;opacity:1;transition:opacity 200ms ease-in-out}.ky5wc .RRTjT{opacity:0;pointer-events:none}.AhsFx{flex-shrink:0}.ky5wc .AhsFx{margin-left:auto}.I9GLv{margin-left:auto;flex-shrink:0}.gQHsl{flex:1;min-height:0;display:flex;flex-direction:column;overflow:hidden;opacity:1;transition:opacity 200ms ease-in-out}.ky5wc .gQHsl{opacity:0;pointer-events:none}@media(prefers-reduced-motion: reduce){._72Und,.iPrNB,.RRTjT,.gQHsl{transition:none}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"root": `_72Und`,
	"open": `SfmIa`,
	"collapsed": `ky5wc`,
	"paneInner": `FJ0Y9`,
	"header": `iPrNB`,
	"scrolled": `pZJyg`,
	"titleTypography": `kMvhq`,
	"betaBadge": `RRTjT`,
	"chevron": `AhsFx`,
	"clearChat": `I9GLv`,
	"body": `gQHsl`
};
export default ___CSS_LOADER_EXPORT___;
